import { useCallback, useMemo } from 'react';
// @ts-expect-error untyped
import SharedDragDropContext from 'customer-data-ui-utilities/dnd/SharedDragDropContext';
import { useCardContentSectionSettings } from '../../hooks/useCardSections';
import { DraggableList } from './DraggableList';
import { useUpdateDraftSettingOrders } from '../../settings/store/slice/sectionSettingsActions';
import { jsx as _jsx } from "react/jsx-runtime";
const DraggableCardSettingRows = () => {
  const contentSectionSettings = useCardContentSectionSettings();
  const updateDraftSettingOrders = useUpdateDraftSettingOrders();
  const orderedItems = useMemo(() => {
    return contentSectionSettings.map((item, index) => {
      const {
        Component,
        settings,
        sectionKey
      } = item;
      return {
        // Use index to ensure unique ids
        id: `${sectionKey}-${index}`,
        sectionKey,
        ariaLabel: sectionKey,
        children: /*#__PURE__*/_jsx(Component, {
          settings: settings
        })
      };
    });
  }, [contentSectionSettings]);
  const handleOrderChange = useCallback(orderedSectionIds => {
    const updatedSections = orderedSectionIds.map(orderedSectionId => orderedItems.find(currentItem => currentItem.id === orderedSectionId)).filter(section => section !== undefined);
    updateDraftSettingOrders(updatedSections.map(section => section.sectionKey));
  }, [orderedItems, updateDraftSettingOrders]);
  return /*#__PURE__*/_jsx(DraggableList, {
    dragGroupId: "section-setting-rows",
    orderedItems: orderedItems,
    onOrderChange: handleOrderChange
  });
};
export default SharedDragDropContext()(DraggableCardSettingRows);